<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadSmalls(1,null, true)">

      <template slot="actions">
        <!--
        <v-select :placeholder="$t('please_select_a_major_category')" :options="bigs" :reduce="label => label.value" v-model="smallFormData.big_type_id" style="width: 250px;"/>&nbsp;
        -->

        <select v-model="smallFormData.big_type_id" class="vs-inputx vs-input--input normal hasValue configuration-consultation-small-big-dropdown" style="width:240px;" >
          <option value="">{{ $t('please_select_a_major_category') }}</option>
          <option v-for="(option, key) in bigs" :key="'bigs_' + key" :value="option.value">{{ option.label }}</option>
        </select>

        <vx-input-group>
          <vs-input :placeholder="$t('small')" v-model="smallFormData.name" class="configuration-consultation-small-input"/>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button id="addConfigurationSmallButton" color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="addSmall">{{ $t('smalls.button.add_small') }}</vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('smalls.filter.small')" v-model="smallSearchParams.child" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="statusOptions" :reduce="label => label.value" :placeholder="$t('smalls.filter.status')" v-model="smallSearchParams.isActive" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadSmalls(1,null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="smallDataContainer" :title="$t('small')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-configuration-tab-nav></shared-configuration-tab-nav>
      </template>

      <shared-user-configuration-consultation-small-list
        :bigs="bigs"
        :smalls="smalls"
        @customClickStatus="status"
        @customClickEdit="edit"
        @customClickDelete="destroy"
        @customClickSave="save"
        @customClickCancel="cancel"
      ></shared-user-configuration-consultation-small-list>

      <template slot="footer">
        <paginate
          :total="smallPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadSmalls"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>
  </div>
</template>

<script>
import SharedConfigurationTabNav from '@/views/Shared/Configuration/TabNav'
import Small from '@/models/Small'
import SharedUserConfigurationConsultationSmallList from '@/views/Shared/Configuration/Consultation/Smalls/List'
import Paginate from '@/mixins/paginate'
import { statusOptions } from '@/config/options'

export default {
  name: 'User.Configuration.Consultation.Smalls',
  mixins: [Paginate],
  components: {
    SharedConfigurationTabNav,
    SharedUserConfigurationConsultationSmallList
  },
  data () {
    return {
      smallsEdit: {},
      bigs: [],
      smalls: {},
      smallPages: 1,
      smallFormData: {
        big_type_id: '',
        name: '',
        is_active: '',
        id: ''
      },
      smallFormErrors: {},
      itemPerPage: null,
      smallSearchParams: {
        child: typeof this.$route.query.child !== 'undefined' ? this.$route.query.child : '',
        isActive: typeof this.$route.query.isActive !== 'undefined' ? this.$route.query.isActive : ''
      },
      statusOptions
    }
  },
  mounted () {
    this.loadSmalls(this.initialPage, null, false, true)
  },
  methods: {
    async loadSmalls (page = 1, itemPerPage = null, backToPageOne = false, isOnLoad = false) {
      this.$vs.loading({container: '#smallDataContainer'})
      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }
      if (!isOnLoad) {
        this.$router.replace({ query: { ...this.smallSearchParams, page, itemPerPage }})
      }
      const response = await Small.all({ ...this.smallSearchParams, page, itemPerPage })
      this.smalls = response.data.data.smalls
      this.bigs = Object.values(response.data.meta.options.bigs)
      this.smallPages = response.data.meta.pagination.last_page
      this.itemPerPage = response.data.meta.pagination.per_page
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#smallDataContainer > .con-vs-loading')
    },
    async addSmall (e) {
      e.preventDefault()
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationSmallButton', scale: 0.45})
      if (this.smallFormData.big_type_id.length === 0 && this.smallFormData.name.length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_small_error_message_if_not_select_big_and_empty_small'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.smallFormData.big_type_id.length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_small_error_message_if_not_select_big'),
          confirmButton: this.$t('confirm')
        })

      } else if (this.smallFormData.name.length === 0) {

        await this.$swalHelper.error({
          title: '',
          text: this.$t('add_small_error_message_if_empty_small'),
          confirmButton: this.$t('confirm')
        })

      } else if (!this.$store.getters.isFormInProgress) {
        this.$store.dispatch('setIsFormInProgress', true)
        await Small.save(this.smallFormData)
        this.$store.dispatch('setIsFormInProgress', false)
        this.loadSmalls(1, this.itemPerPage)
        this.smallFormData = {
          big_type_id: '',
          name: '',
          is_active: '',
          id: ''
        }
        this.ringGroupFormErrors = {}
      }
      this.$vs.loading.close('#addConfigurationSmallButton > .con-vs-loading')
    },
    async status (key) {
      try {
        if (this.smalls[key].is_active === 1) {
          this.smalls[key].is_active = 0
        } else {
          this.smalls[key].is_active = 1
        }
        await Small.update(this.smalls[key])
        this.smalls[key].smallFormErrors = {}
      } catch (e) {
        this.smalls[key].smallFormErrors = e.response.data.errors
      }
    },
    async edit (key) {
      this.smalls[key].edit = true
      const editElem = this.smalls[key]
      const editObj = {
        name: editElem.name,
        big_type_id: editElem.big_type_id
      }
      this.smallsEdit[key] = editObj
    },
    async cancel (key) {
      this.smalls[key].name = this.smallsEdit[key].name
      this.smalls[key].big_type_id = this.smallsEdit[key].big_type_id
      this.smalls[key].edit = false
      this.smalls[key].smallFormErrors = {}
      delete this.smallsEdit[key]
    },
    async save (key, id) {
      try {
        const confirm = await this.$swalHelper.warning({
          title: this.$t('small_update_confirmation_title'),
          text: this.$t('small_update_confirmation_text'),
          confirmButton: this.$t('execution'),
          cancelButton: this.$t('cancel')
        })
        if (confirm.value) {

          this.$vs.loading({background: 'primary', color: '#fff', container: `#updateConfigurationSmallButton${id}`, scale: 0.45})

          await Small.update(this.smalls[key])
          this.smalls[key].edit = false

          for (const i in this.bigs) {
            if (this.smalls[key].big_type_id === this.bigs[i].value) {
              this.smalls[key].big_type_name = this.bigs[i].label
            }
          }

          this.smalls[key].smallFormErrors = {}
          this.$vs.loading.close(`#updateConfigurationSmallButton${  id  } > .con-vs-loading`)
        }
      } catch (e) {
        this.smalls[key].smallFormErrors = e.response.data.errors
        this.$vs.loading.close(`#updateConfigurationSmallButton${  id  } > .con-vs-loading`)
      }
    },
    async destroy (key, id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await Small.delete(id)
        this.loadSmalls(1, this.itemPerPage)
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationSmallButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>
